import type { CSSProperties } from 'react';

import { Progress } from '@ark-ui/react';

import { cn } from '../../lib/utils';

type CircularProgressColor = 'accent' | 'gray' | 'green' | 'red' | 'amber';

interface CircularProgressProps {
	value: number;
	max?: number;
	size?: number;
	strokeWidth?: number;
	variant?: 'solid' | 'dashed';
	color?: CircularProgressColor;
	className?: string;
}

export function CircularProgress({
	value,
	max = 100,
	size = 32,
	strokeWidth = 4,
	variant = 'solid',
	color = 'accent',
	className
}: CircularProgressProps) {
	return (
		<Progress.Root
			className={cn('pt-circular-progress', className)}
			data-color={color}
			data-variant={variant}
			data-slot="circular-progress"
			value={value}
			max={max}
			style={
				{
					'--size': `${size}px`,
					'--thickness': `${strokeWidth}px`
				} as CSSProperties
			}
		>
			<Progress.Circle className="pt-circular-progress-circle">
				<Progress.CircleTrack className="pt-circular-progress-track" />
				{variant !== 'dashed' && <Progress.CircleRange className="pt-circular-progress-range" />}
			</Progress.Circle>
		</Progress.Root>
	);
}
